function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V7H22V9H21V13H19V6H4V17H15V19H6V20H4V19C3.46957 19 2.96086 18.7893 2.58579 18.4142C2.21071 18.0391 2 17.5304 2 17V6C2 5.46957 2.21071 4.96086 2.58579 4.58579Z",
  className: "icon-primary"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 7.5C12.4391 7.5 11.4217 7.92143 10.6716 8.67157C9.92143 9.42172 9.5 10.4391 9.5 11.5C9.5 12.5609 9.92143 13.5783 10.6716 14.3284C11.4217 15.0786 12.4391 15.5 13.5 15.5C14.5609 15.5 15.5783 15.0786 16.3284 14.3284C17.0786 13.5783 17.5 12.5609 17.5 11.5C17.5 10.4391 17.0786 9.42172 16.3284 8.67157C15.5783 7.92143 14.5609 7.5 13.5 7.5ZM5 9V14H7V9H5ZM13.5 9.5C14.0304 9.5 14.5391 9.71071 14.9142 10.0858C15.2893 10.4609 15.5 10.9696 15.5 11.5C15.5 12.0304 15.2893 12.5391 14.9142 12.9142C14.5391 13.2893 14.0304 13.5 13.5 13.5C12.9696 13.5 12.4609 13.2893 12.0858 12.9142C11.7107 12.5391 11.5 12.0304 11.5 11.5C11.5 10.9696 11.7107 10.4609 12.0858 10.0858C12.4609 9.71071 12.9696 9.5 13.5 9.5Z",
  className: "icon-primary"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.125 21L20 19.8206L21.8375 21L21.35 18.7757L23 17.2876L20.8325 17.0897L20 15L19.1525 17.0897L17 17.2876L18.635 18.7757L18.125 21Z",
  className: "icon-primary"
});

function SvgVaultProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "icon-primary",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultProfile);
export default __webpack_public_path__ + "static/media/vault-profile.d806d32f.svg";
export { ForwardRef as ReactComponent };